import { SourcingOpeningDetailsResponse } from 'api-clients/monolith';
import { useEffect } from 'react';

import { useEditTargetsContext } from '@/contexts/edit-targets-context';
import { useHireUrl } from '@/hooks/use-hire-url';
import { useOpeningSlug } from '@/hooks/use-opening-slug';

export function useEditTargets(funnelData: SourcingOpeningDetailsResponse) {
  const openingSlug = useOpeningSlug();
  const { setHiringGoal, setHiringGoalUrl } = useEditTargetsContext();
  const { getHireATHiringGoalUrl } = useHireUrl();

  const { hiring_goal: hiringGoal } = funnelData;

  useEffect(() => {
    setHiringGoalUrl(
      getHireATHiringGoalUrl(
        funnelData.brand_slug ?? 'no_brand',
        funnelData.location_id,
        funnelData.opening_id,
      ),
    );

    if (!hiringGoal) return;
    setHiringGoal({
      openingSlug,
      openingName: funnelData.title,
      startDate: hiringGoal.start_date,
      endDate: hiringGoal.hire_by,
      goal: hiringGoal.hire_stats.expected ?? 0,
      duration: hiringGoal.duration,
      is_current: hiringGoal.is_current,
    });
  }, [
    hiringGoal,
    setHiringGoal,
    openingSlug,
    setHiringGoalUrl,
    funnelData,
    getHireATHiringGoalUrl,
  ]);
}
